import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";
import type { Staff } from "@/lib/authv2/store";

/** Gương `auth.Allow("set_board.read")`; phạm vi cơ sở do máy chủ soát. */
export function canSeeSetBoard(staff: Staff | null | undefined): boolean {
  return Boolean(staff) && hasPermission(ACTION.SetBoardRead);
}
